/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClaimFaucetResponse, ClaimFaucetVars } from '../openapi-types.gen.js';

export type { ClaimFaucetResponse, ClaimFaucetVars } from '../openapi-types.gen.js';

export const useClaimFaucet = createMutationHook<ClaimFaucetVars, ClaimFaucetResponse, unknown>({
  specName: 'useClaimFaucet',
  path: '/v1/faucet/claim',
  method: 'POST',
  resolveUrl: (vars: ClaimFaucetVars) => `/v1/faucet/claim`,
  buildBody: (vars: ClaimFaucetVars) => ({ walletAddress: vars.walletAddress, amountUsdc: vars.amountUsdc }),
  parseResponse: (raw: unknown): ClaimFaucetResponse => raw as ClaimFaucetResponse,
  
  
  
});
